import React, { useState, useEffect } from "react";
import styled, { keyframes, css } from "styled-components";

import Close from "../../images/close_icon.png";

import feeIcon1 from "../../images/fee_icon_1.png";
import feeIcon2 from "../../images/fee_icon_2.png";
import feeIcon3 from "../../images/fee_icon_3.png";
const fadeIn = keyframes`
  from {
    opacity: 0
  }
  to {
    opacity: 1
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1
  }
  to {
    opacity: 0
  }
`;

const slideUp = keyframes`
  from {
    transform: translateY(200px);
  }
  to {
    transform: translateY(0px);
  }
`;

const slideDown = keyframes`
  from {
    transform: translateY(0px);
  }
  to {
    transform: translateY(200px);
  }
`;

export const DarkBackground = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);

  animation-duration: 0.25s;
  animation-timing-function: ease-out;
  animation-name: ${fadeIn};
  animation-fill-mode: forwards;
  z-index: 100;

  ${(props) =>
    props.disappear &&
    css`
      animation-name: ${fadeOut};
    `}
`;

const DialogBlock = styled.div`
  position: absolute;
  width: 550px;
  height: 90vh;

  background: #ffffff;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.15);
  border-radius: 15px;

  display: flex;
  /* align-items: center; */
  justify-content: center;

  animation-duration: 0.25s;
  animation-timing-function: ease-out;
  animation-name: ${slideUp};
  animation-fill-mode: forwards;

  ${(props) =>
    props.disappear &&
    css`
      animation-name: ${slideDown};
    `}

  p {
    position: absolute;
    left: 106px;
    top: 120px;
    font-family: Sandoll GothicNeo1;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 15px;
    /* identical to box height, or 75% */

    text-align: center;

    color: #000000;
  }
`;

export const ExitButton = styled.img`
  width: 20px;
  height: 20px;

  position: absolute;
  right: 20px;
  top: 20px;
`;
ExitButton.defaultProps = {
  src: Close,
};

const SubmitButton = styled.div`
  width: 100%;
  height: 50px;

  border-radius: 0 0 10px 10px;
  position: absolute;
  bottom: 0;

  background: ${(props) => props.color || "#C7C7C7"};

  display: flex;
  justify-content: center;
  align-items: center;

  span {
    font-family: Noto Sans KR;
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 26px;

    color: #ffffff;
  }
`;

const DialogContentWrapper = styled.div`
  display: flex;

  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;

  padding-bottom: 50px;
  padding-top: 50px;

`;

const DialogTitle = styled.div`
  font-family: Noto Sans KR;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 35px;

  color: #000000;

  /* position: absolute; */
  /* top: 50px; */

  /* margin-bottom: 13px; */
`;

const DialogText = styled.div`
  font-family: Noto Sans KR;
  font-style: normal;
  font-weight: normal;
  font-size: 17px;
  line-height: 25px;
  /* identical to box height */
  text-align: center;
  /* margin-bottom: 40px; */
  margin-top : -20px;

  /* position: absolute; */
  /* top: 100px; */

  /* basic / gray / 1 */
  color: #5c5c5c;
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;
`;

const FeeInput = styled.input`
  width: ${(props) => props.width || 300}px;
  height: ${(props) => props.height || 50}px;

  font-size: 15px;
  padding: 15px;
  border: 1px solid #cccccc;
  box-sizing: border-box;
  border-radius: 5px;

  background: ${(props) => props.color || "#ffffff"};

  ::placeholder {
    color: #8f8f8f;
  }
`;

const UnitText = styled.div`
  font-family: Noto Sans KR;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 26px;

  margin-left: 10px;
  margin-right: ${(props) => props.marginRight || 0}px;
  position: relative;
  top: 10px;

  color: #000000;
`;

const InputTitle = styled.div`
  font-family: Noto Sans KR;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 26px;

  color: #000000;

   margin-bottom: 5px; 

  span {
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 26px;

    color: #000000;
  }
`;

const TitleIcon = styled.img`
  width: ${(props) => props.iconWidth || 15}px;
  height: ${(props) => props.iconHeight || 14}px;
`;

const SingleInputBox = styled.div`
  display: flex;
  flex-direction: column;

  /* margin-bottom: 30px; */
`;

function SingleInput({
  titleText,
  caption,
  unitText,
  placeholder,
  src,
  iconHeight,
  iconWidth,
  ...rest
}) {
  return (
    <SingleInputBox>
      <InputTitle>
        <TitleIcon
          src={src}
          iconHeight={iconHeight}
          iconWidth={iconWidth}
        ></TitleIcon>{" "}
        {titleText} <span> {caption} </span>
      </InputTitle>
      <InputWrapper>
        <FeeInput type="number" placeholder={placeholder} {...rest}></FeeInput>
        <UnitText> {unitText} </UnitText>
      </InputWrapper>
    </SingleInputBox>
  );
}

function DoubleInput({
  titleText,
  caption,
  unitText1,
  unitText2,
  placeholder1,
  placeholder2,
  src,
  iconHeight,
  iconWidth,
  onChange,
  onChange1,
  ...rest
}) {
  return (
    <SingleInputBox>
      <InputTitle>
        <TitleIcon
          src={src}
          iconHeight={iconHeight}
          iconWidth={iconWidth}
        ></TitleIcon>{" "}
        {titleText} <span> {caption} </span>
      </InputTitle>
      <InputWrapper>
        <FeeInput
          onChange={onChange1}
          width="117"
          type="number"
          placeholder={placeholder1}
          {...rest}
        ></FeeInput>
        <UnitText marginRight="40"> {unitText1} </UnitText>
        <FeeInput
          onChange={onChange}
          width="117"
          type="number"
          placeholder={placeholder2}
          {...rest}
        ></FeeInput>
        <UnitText> {unitText2} </UnitText>
      </InputWrapper>
    </SingleInputBox>
  );
}

function FeeDialog({ onClose, visible, onMaskClick }) {
  const [animate, setAnimate] = useState(false);
  const [localVisible, setLocalVisible] = useState(visible);

  let [weekdayFee, setWeekdayFee] = useState("");
  let [weekendFee, setWeekendFee] = useState("");
  let [timePassFee, setTimePassFee] = useState("");
  let [monthPassNum, setMonthPassNum] = useState("");
  let [monthPassFee, setMonthPassFee] = useState("");
  let [dayPassNum, setDayPassNum] = useState("");
  let [dayPassFee, setDayPassFee] = useState("");

  useEffect(() => {
    // visible 값이 true -> false 가 되는 것을 감지
    if (localVisible && !visible) {
      setAnimate(true);
      setTimeout(() => setAnimate(false), 250);
    }
    setLocalVisible(visible);
  }, [localVisible, visible]);

  if (!animate && !localVisible) return null;


const onClickSubmit = (e) => {
    if(weekdayFee !== "" && weekendFee !== ""){
        if (e.target === e.currentTarget) {

            sessionStorage.setItem("weekdayFee", weekdayFee);
            sessionStorage.setItem("weekendFee", weekendFee);
            sessionStorage.setItem("timePassFee", timePassFee);
            sessionStorage.setItem("monthPassNum", monthPassNum);
            sessionStorage.setItem("monthPassFee", monthPassFee);
            sessionStorage.setItem("dayPassNum", dayPassNum);
            sessionStorage.setItem("dayPassFee", dayPassFee);
            sessionStorage.setItem("submitComplete", true);

          onClose(e);
        }
      }
    };

  return (
    <DarkBackground disappear={!visible} onClick={onMaskClick}>
      <DialogBlock disappear={!visible}>
        <ExitButton onClick={onClose} />
        <DialogContentWrapper>
          <DialogTitle> 💵 주차장 요금제 </DialogTitle>
          <DialogText>내 주차장의 주차 요금을 선택하여 입력해주세요</DialogText>
          <SingleInput
            src={""}
            iconHeight="0"
            iconWidth="0"
            titleText="평일"
            caption="1시간 평균 요금"
            placeholder="숫자로 입력해 주세요 예)10000"
            unitText="원"
            onChange={(e) => {
              setWeekdayFee(e.target.value);
              console.log(weekdayFee);
            }}
          ></SingleInput>
          <SingleInput
            src={""}
            iconHeight="0"
            iconWidth="0"
            titleText="주말"
            caption="1시간 평균 요금"
            placeholder="숫자로 입력해 주세요 예)10000"
            unitText="원"
            onChange={(e) => {
              setWeekendFee(e.target.value);
            }}
          ></SingleInput>
          <SingleInput
            src={feeIcon1}
            iconHeight="15"
            iconWidth="15"
            titleText="시간권 대수"
            placeholder="시간권 대수"
            unitText="대"
            onChange={(e) => {
              setTimePassFee(e.target.value);
            }}
          ></SingleInput>
          <DoubleInput
            src={feeIcon2}
            iconHeight="16"
            iconWidth="16"
            titleText="월 정기권"
            placeholder1="정기권 대수"
            unitText1="대"
            placeholder2="정기권 요금"
            unitText2="원"
            onChange1={(e) => {
              setMonthPassNum(e.target.value);
            }}
            onChange={(e) => {
              setMonthPassFee(e.target.value);
            }}
          ></DoubleInput>
          <DoubleInput
            src={feeIcon3}
            iconHeight="14"
            iconWidth="24"
            titleText="일 정기권"
            placeholder1="정기권 대수"
            unitText1="대"
            placeholder2="정기권 요금"
            unitText2="원"
            onChange1={(e) => {
              setDayPassNum(e.target.value);
            }}
            onChange={(e) => {
              setDayPassFee(e.target.value);
            }}
          ></DoubleInput>
        </DialogContentWrapper>
        <SubmitButton
          color={
            (weekdayFee !== "" && weekendFee !== "")
              ? "#EF8A57"
              : "#C7C7C7"
          }
          onClick={onClickSubmit}
        >
          <span> 입력 완료 </span>
        </SubmitButton>
      </DialogBlock>
    </DarkBackground>
  );
}

export default FeeDialog;

/*

    const [dialog,setDialog] = useState(false);
    const onClick = () => {
        setDialog(true);
    };
    const onClose=()=>{
        setDialog(false)
    }

*/
